/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RequestToExplainCommissionCutsMutationVariables = {
    agentId: string;
    reason: string;
};
export type RequestToExplainCommissionCutsMutationResponse = {
    readonly requestToExplainCommissionCuts: {
        readonly result: string;
    } | null;
};
export type RequestToExplainCommissionCutsMutation = {
    readonly response: RequestToExplainCommissionCutsMutationResponse;
    readonly variables: RequestToExplainCommissionCutsMutationVariables;
};



/*
mutation RequestToExplainCommissionCutsMutation(
  $agentId: String!
  $reason: String!
) {
  requestToExplainCommissionCuts(agentId: $agentId, reason: $reason) {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reason"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "agentId",
        "variableName": "agentId"
      },
      {
        "kind": "Variable",
        "name": "reason",
        "variableName": "reason"
      }
    ],
    "concreteType": "RequestToExplainCommissionCuts",
    "kind": "LinkedField",
    "name": "requestToExplainCommissionCuts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RequestToExplainCommissionCutsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RequestToExplainCommissionCutsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "324ef3a28de38a401ceeac035399d999",
    "id": null,
    "metadata": {},
    "name": "RequestToExplainCommissionCutsMutation",
    "operationKind": "mutation",
    "text": "mutation RequestToExplainCommissionCutsMutation(\n  $agentId: String!\n  $reason: String!\n) {\n  requestToExplainCommissionCuts(agentId: $agentId, reason: $reason) {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = '0fbc4e80c51d608d4c38319a726a940b';
export default node;
